<template>
  <div class="bg-white">
    <CoverPage />
    <Form />
  </div>
</template>
<script>
import CoverPage from "./components/CoverPage.vue";
import Form from "./components/Form.vue";
export default {
  components: {
    CoverPage,
    Form
  }
};
</script>
